const form = `
  <div class="wizard-nav" id="{{ wizardKey }}-nav">
    <button
      class="btn-wizard btn-wizard-forward btn-wizard-{{ buttons.next ? 'next' : 'submit' }}"
      ref="{{ wizardKey }}-{{ buttons.next ? 'next' : 'submit' }}"
    >
      {{ buttons.next ? 'Next' : 'Submit' }}
    </button>
    {% if (t(panels[currentPage].title) !== 'Daily Survey') { %}
    <button 
      class="btn-wizard btn-wizard-backward btn-wizard-save" ref="{{ wizardKey }}-save"
    >
      Save
    </button>
    {% } %}
    <button 
      class="btn-wizard btn-wizard-backward btn-wizard-{{ buttons.previous ? 'previous' : 'cancel' }}"
      {% if (buttons.previous) { %}
        ref="{{ wizardKey }}-previous"
      {% } %}
    >
      Back
    </button>
  </div>
`;

export default form;
